module.exports = __webpack_public_path__ + "static/cAlgo_logo.646fdb32.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/cAlgo_logo.png
// module id = 505
// module chunks = 79718873386587